import { Helmet } from "react-helmet"

const SEO = ({ title, description }) => {

return (

<Helmet>

<title>{title}</title>

<meta name="description" content={description} />

<meta property="og:title" content={title} />

<meta property="og:description" content={description} />

<meta property="og:type" content="article" />

</Helmet>

)

}

export default SEO